export const APPOINTMENT = 'WEBAPP_APPOINTMENT_PAGE';
export const BRAND_MODEL = 'WEBAPP_BRAND_MODEL_PAGE';
export const CALL_ME_BACK = 'WEBAPP_CALL_ME_BACK_PAGE';
export const CAR_DESTINATIONS = 'WEBAPP_CAR_DESTINATIONS_PAGE';
export const CONFIRMATION = 'WEBAPP_CONFIRMATION_PAGE';
export const DELIVERY = 'WEBAPP_DELIVERY_PAGE';
export const ELIGIBILITY = 'WEBAPP_ELIGIBILITY_PAGE';
export const IDENTIFICATION = 'WEBAPP_IDENTIFICATION_PAGE';
export const END_APPOINTMENT = 'WEBAPP_END_APPOINTMENT_PAGE';
export const END_MISSION = 'WEBAPP_END_MISSION_PAGE';
export const EVENTS = 'WEBAPP_EVENTS_PAGE';
export const EVENT_DETAILS = 'WEBAPP_EVENT_DETAILS_PAGE';
export const SPECIFIC_EVENTS_DETAILS = 'WEBAPP_SPECIFIC_EVENTS_DETAILS_PAGE';
export const FNOL_ACCIDENT_STATEMENT = 'WEBAPP_FNOL_ACCIDENT_STATEMENT_SCREEN_PAGE';
export const FNOL_APPOINTMENT = 'WEBAPP_FNOL_APPOINTMENT_PAGE';
export const FNOL_CIRCUMSTANCES_DETAILS = 'WEBAPP_FNOL_CIRCUMSTANCES_DETAILS_PAGE';
export const FNOL_DAMAGES = 'WEBAPP_FNOL_DAMAGES_SCREEN_PAGE';
export const FNOL_SITUATION_DETAILS = 'WEBAPP_FNOL_SITUATION_DETAILS_PAGE';
export const FNOL_THIRD_PARTY_INFO = 'WEBAPP_FNOL_THIRD_PARTY_INFO_PAGE';
export const HIGHWAY_DIRECTION = 'WEBAPP_HIGHWAY_DIRECTION_PAGE';
export const HIGHWAY_PROCESS = 'WEBAPP_HIGHWAY_PROCESS_PAGE';
export const LEGISLATION = 'WEBAPP_LEGISLATION_PAGE';
export const LOCATION_DETAILS = 'WEBAPP_LOCATION_DETAILS_PAGE';
export const MILESTONE = 'WEBAPP_MILESTONE_PAGE';

export const PREVIOUS_CLAIM_HANDLING = 'WEBAPP_PREVIOUS_CLAIM_HANDLING_PAGE';
export const RENTAL_SERVICE = 'WEBAPP_RENTAL_SERVICE_PAGE';
export const RENTAL_EXTENSION = 'WEBAPP_RENTAL_EXTENSION_PAGE';

export const SPLASH_SCREEN = 'WEBAPP_SPLASH_SCREEN_PAGE';
export const VEHICLE_LOCATION = 'WEBAPP_VEHICLE_LOCATION_PAGE';
export const VOICE_EXIT = 'WEBAPP_VOICE_EXIT_PAGE';
export const WELCOME = 'WEBAPP_WELCOME_PAGE';
export const ADDITIONAL_TRANSPORTATION = 'ADDITIONAL_TRANSPORTATION_PAGE';
export const BENEFIT_SELECTION = 'WEBAPP_RENTAL_SELECTION_PAGE';

export const RENTAL_CAR_WELCOME = 'WEBAPP_RENTAL_CAR_WELCOME_PAGE';
export const RENTAL_REGISTRATION = 'WEBAPP_RENTAL_REGISTRATION_PAGE';
export const RENTAL_ELIGIBILITY = 'WEBAPP_RENTAL_ELIGIBILITY_PAGE';
export const RENTAL_SUMMARY = 'WEBAPP_RENTAL_SUMMARY_PAGE';
export const RENTAL_CAR_DRIVER_DETAILS = 'WEBAPP_RENTAL_CAR_DRIVER_DETAILS';
export const RENTAL_INFO_CONFIRM = 'WEBAPP_RENTAL_INFO_CONFIRM';
export const RENTAL_MISSION_CANCELLED = 'WEBAPP_RENTAL_MISSION_CANCELLED';
export const RENTAL_INFORMATION = 'WEBAPP_RENTAL_INFORMATION';
export const RENTAL_VEHICLE_LOCATION_GARAGE_CONFIRM = 'WEBAPP_RENTAL_VEHICLE_LOCATION_GARAGE_CONFIRM';
export const RENTAL_VEHICLE_OTHER_LOCATION = 'WEBAPP_RENTAL_VEHICLE_OTHER_LOCATION';
export const RENTAL_VEHICLE_LOCATION_SUMMARY = 'WEBAPP_RENTAL_VEHICLE_LOCATION_SUMMARY';
export const RENTAL_EXTENSION_VEHICLE_LOCATION = 'WEBAPP_RENTAL_EXTENSION_VEHICLE_LOCATION';
export const RENTAL_EXTENSION_NOT_ELIGIBLE = 'WEBAPP_RENTAL_EXTENSION_NOT_ELIGIBLE';
export const RENTAL_EXTENSION_DURATION = 'WEBAPP_RENTAL_EXTENSION_DURATION';
export const RENTAL_EXTENSION_CONFIRMATION = 'WEBAPP_RENTAL_EXTENSION_CONFIRMATION';

export const HIGHWAY_SELECTION = 'WEBAPP_HIGHWAY_SELECTION_PAGE';
export const REFERENTIAL_HIGHWAY_DIRECTION = 'WEBAPP_REFERENTIAL_HIGHWAY_DIRECTION_PAGE';
export const POI_LOCATION = 'WEBAPP_POI_LOCATION_PAGE';

export const eventTags = {
  splash_screen_skip: {
    action: 'skip_splash',
    event_category: 'splash_screen',
    event_label: 'Skip',
  },
  splash_screen_next: {
    action: 'next_splash',
    event_category: 'splash_screen',
    event_label: 'Next',
  },
  welcome_check_conditions: {
    action: 'check_conditions',
    event_category: 'welcome',
    event_label: 'I agreed and accepted conditions',
  },
  welcome_accept_conditions: {
    action: 'accept_conditions',
    event_category: 'welcome',
    event_label: 'Register',
  },
  eligibility_check: {
    action: 'check_eligibility',
    event_category: 'eligibility',
    event_label: 'Confirm',
  },
  eligibility_recheck: {
    action: 'recheck_eligibility',
    event_category: 'eligibility_not_found',
    event_label: 'Recheck Information',
  },
  eligibility_continue_process: {
    action: 'continue_process',
    event_category: 'eligibility_not_found',
    event_label: 'Continue Process',
  },
  eligibility_expired_recheck: {
    action: 'recheck_eligibility',
    event_category: 'eligibility_expired',
    event_label: 'Recheck Information',
  },
  eligibility_expired_continue_process: {
    action: 'continue_process',
    event_category: 'eligibility_expired',
    event_label: 'Continue Process',
  },
  identification_continue: {
    action: 'continue_identification',
    event_category: 'identification',
    event_label: 'Continue',
  },
  identification_check_information: {
    action: 'check_information',
    event_category: 'identification',
    event_label: 'Check Information',
  },
  brand_modal_select_brand: {
    action: 'select_brand',
    event_category: 'brand_modal',
  },
  brand_modal_select_model: {
    action: 'select_model',
    event_category: 'brand_modal',
  },
  brand_modal_confirm: {
    action: 'confirm_brand_model_data',
    event_category: 'brand_modal',
    event_label: 'Confirm',
  },
  events_select: {
    action: 'select_event',
    event_category: 'events',
  },
  events_expand_other_events: {
    action: 'expand_other_events',
    event_category: 'events',
    event_label: 'Other',
  },
  events_collapse_other_events: {
    action: 'collapse_other_events',
    event_category: 'events',
    event_label: 'Other',
  },
  event_details_select_spare_tire: {
    action: 'select_spare_tire',
    event_category: 'events_details',
  },
  event_details_select_person_with_special_needs: {
    action: 'select_person_with_special_needs',
    event_category: 'events_details',
  },
  event_details_select_car_drivable: {
    action: 'select_car_drivable',
    event_category: 'events_details',
  },
  event_details_select_car_fuel_type: {
    action: 'select_car_fuel_type',
    event_category: 'events_details',
  },
  event_details_select_car_off_road: {
    action: 'select_car_off_road',
    event_category: 'events_details',
  },
  event_details_select_car_upside_down: {
    action: 'select_car_upside_down',
    event_category: 'events_details',
  },
  event_details_select_windscreen_details: {
    action: 'select_windscreen_details',
    event_category: 'events_details',
  },
  event_details_select_flat_tire: {
    action: 'select_flat_tire',
    event_category: 'events_details',
  },
  event_details_select_breakdown_type: {
    action: 'select_breakdown_type',
    event_category: 'events_details',
  },
  event_details_select_disaster_type: {
    action: 'select_disaster_type',
    event_category: 'events_details',
  },
  event_details_select_key_broken: {
    action: 'select_key_broken',
    event_category: 'events_details',
  },
  event_details_select_found_after_theft: {
    action: 'select_found_after_theft',
    event_category: 'events_details',
  },
  event_details_select_hybrid_energy: {
    action: 'select_hybrid_energy',
    event_category: 'events_details',
  },
  events_details_select: {
    action: 'select_events_details',
    event_category: 'events_details',
    event_label: 'Confirm',
  },
  specific_events_details_select: {
    action: 'select_specific_events_details',
    event_category: 'specific_events_details',
    event_label: 'Confirm',
  },
  vehicle_location_select: {
    action: 'confirm_vehicle_location',
    event_category: 'vehicle_location',
    event_label: 'Confirm',
  },
  vehicle_location_modal_confirm: {
    action: 'confirm_vehicle_location',
    event_category: 'vehicle_location_modal',
    event_label: 'Confirm',
  },
  vehicle_location_modal_cancel: {
    action: 'cancel_vehicle_location',
    event_category: 'vehicle_location_modal',
    event_label: 'Cancel',
  },
  location_details_highway: {
    action: 'select_highway',
    event_category: 'location_details',
  },
  location_details_covered_garage: {
    action: 'select_covered_garage',
    event_category: 'location_details',
  },
  location_details_select: {
    action: 'confirm_location_details',
    event_category: 'location_details',
    event_label: 'Confirm',
  },
  location_details_highway_mismatch_confirm: {
    action: 'confirm_highway_mismatch',
    event_category: 'location_details',
    event_label: 'Confirm Highway Despite Mismatch',
  },
  location_details_highway_mismatch_cancel: {
    action: 'cancel_highway_mismatch',
    event_category: 'location_details',
    event_label: 'Cancel Highway Mismatch',
  },
  milestone_enter_mileage: {
    action: 'enter_milestone_mileage',
    event_category: 'milestone_mileage',
    event_label: 'Confirm',
  },
  highway_direction_select: {
    action: 'select_highway_direction',
    event_category: 'highway_direction',
    event_label: 'Confirm',
  },
  car_destinations_select_unknown_destination: {
    action: 'select_unknown_destination',
    event_category: 'car_destinations',
  },
  car_destinations_edit_location: {
    action: 'edit_location',
    event_category: 'car_destinations',
    event_label: 'My location address',
  },
  car_destinations_edit_custom_location: {
    action: 'edit_location',
    event_category: 'car_destinations',
    event_label: 'My custom address',
  },
  car_destinations_click_next_provider: {
    action: 'next_car_destination',
    event_category: 'car_destinations',
    event_label: 'Next',
  },
  car_destinations_click_previous_provider: {
    action: 'previous_car_destination',
    event_category: 'car_destinations',
    event_label: 'Previous',
  },
  car_destinations_swipe_provider: {
    action: 'swipe_car_destination',
    event_category: 'car_destinations',
    event_label: 'Swipe',
  },
  edit_location_dialog_confirm: {
    action: 'confirm_location_dialog',
    event_category: 'edit_location_dialog',
    event_label: 'Confirm',
  },
  edit_location_dialog_close: {
    action: 'close_location_dialog',
    event_category: 'edit_location_dialog',
    event_label: 'Close',
  },
  car_destinations_select_garage: {
    action: 'select_garage',
    event_category: 'car_destinations',
    event_label: 'Confirm',
  },
  appointment_select_now: {
    action: 'select_now',
    event_category: 'appointment_now',
    event_label: 'Now',
  },
  appointment_select_later: {
    action: 'select_later',
    event_category: 'appointment_later',
    event_label: 'Later',
  },
  appointment_confirm_now: {
    action: 'confirm_now',
    event_category: 'appointment_now',
    event_label: 'Confirm',
  },
  appointment_confirm_later: {
    action: 'confirm_later',
    event_category: 'appointment_later',
    event_label: 'Confirm',
  },
  summary_confirm: {
    action: 'confirm_summary',
    event_category: 'summary',
    event_label: 'Confirm',
  },
  summary_cancel: {
    action: 'cancel_summary',
    event_category: 'summary',
    event_label: 'Cancel',
  },
  summary_modal_confirm_Cancellation: {
    action: 'permit_to_cancel',
    event_category: 'summary_cancelation_modal',
    event_label: 'Yes',
  },
  summary_modal_refuse_Cancellation: {
    action: 'deny_to_cancel',
    event_category: 'summary_cancelation_modal',
    event_label: 'No',
  },
  summary_modal_confirm_to_modify: {
    action: 'permit_to_modify',
    event_category: 'summary_modification_modal',
    event_label: 'Yes',
  },
  summary_modal_cancel_to_modify: {
    action: 'cancel_to_modify',
    event_category: 'summary_modification_modal',
    event_label: 'No',
  },
  confirmation_edit_event_button: {
    action: 'edit_event',
    event_category: 'confirmation_page',
    event_label: 'Edit event',
  },
  confirmation_edit_location_button: {
    action: 'edit_location',
    event_category: 'confirmation_page',
    event_label: 'Edit location',
  },
  confirmation_edit_car_destination_button: {
    action: 'edit_car_destination',
    event_category: 'confirmation_page',
    event_label: 'Edit car destination',
  },
  confirmation_edit_location_details_button: {
    action: 'edit_location_details',
    event_category: 'confirmation_page',
    event_label: 'Edit location details',
  },
  confirmation_cancel_modal_confirm: {
    action: 'confirm_to_cancel',
    event_category: 'confirmation_page',
    event_label: 'Yes',
  },
  confirmation_cancel_modal_refuse: {
    action: 'refuse_to_cancel',
    event_category: 'confirmation_page',
    event_label: 'No',
  },
  end_appointment_cancel: {
    action: 'cancel_appointment',
    event_category: 'end_appointment',
    event_label: 'Cancel',
  },
  end_appointment_update: {
    action: 'update_appointment',
    event_category: 'end_appointment',
    event_label: 'Update',
  },
  end_appointment_confirm_cancelation_modal: {
    action: 'confirm_cancelation',
    event_category: 'end_appointment_cancelation_modal',
    event_label: 'Yes',
  },
  end_appointment_refuse_cancelation_modal: {
    action: 'refuse_cancelation',
    event_category: 'end_appointment_cancelation_modal',
    event_label: 'No',
  },
  end_appointment_confirm_update_modal: {
    action: 'confirm_update',
    event_category: 'end_appointment_update_modal',
    event_label: 'Yes',
  },
  end_appointment_cancel_update_modal: {
    action: 'cancel_update',
    event_category: '   ',
    event_label: 'No',
  },
  delivery_confirm_provider_arrival: {
    action: 'confirm_provider_arrival',
    event_category: 'provider_arrival_modal',
    event_label: 'Yes',
  },
  delivery_deny_provider_arrival: {
    action: 'deny_provider_arrival',
    event_category: 'provider_arrival_modal',
    event_label: 'No',
  },
  end_mission_call_me_back: {
    action: 'call_me_back',
    event_category: 'end_mission',
    event_label: 'Call Me Back',
  },
  end_mission_confirm_call_back: {
    action: 'confirm_call_back',
    event_category: 'end_mission_modal',
    event_label: 'Yes',
  },
  end_mission_cancel_call_back: {
    action: 'cancel_call_back',
    event_category: 'end_mission_modal',
    event_label: 'No',
  },
  voice_exit_reload: {
    action: 'reload_page',
    event_category: 'voice_exit',
    event_label: 'Reload',
  },
  back_to_previous_page: {
    action: 'back_to_previous_page',
    event_category: 'back',
  },
  nps_confirm_consent: {
    action: 'confirm_consent',
    event_category: 'nps_consent_modal',
    event_label: 'Yes',
  },
  nps_deny_consent: {
    action: 'deny_consent',
    event_category: 'nps_consent_modal',
    event_label: 'No',
  },
  digital_exit: {
    action: 'create_digital_exit',
    event_category: 'digital_exit',
  },
  technical_error: {
    action: 'technical_error',
    event_category: 'technical_error',
  },
  session_error: {
    action: 'session_error',
    event_category: 'technical_error',
    event_label: 'Session error',
  },
  additional_transportation_deny: {
    action: 'deny_additional_transportation',
    event_category: 'additional_transportation',
    event_label: 'No',
  },
  additional_transportation_accept: {
    action: 'accept_additional_transportation',
    event_category: 'additional_transportation',
    event_label: 'Yes',
  },
  additional_transportation_confirm: {
    action: 'confirm_additional_transportation',
    event_category: 'additional_transportation',
    event_label: 'Confirm',
  },
  otp_resend_sms: {
    action: 'resend_sms',
    event_category: 'otp',
    event_label: 'Resend me a code?',
  },
  otp_confirm: {
    action: 'confirm_otp',
    event_category: 'otp',
    event_label: 'Confirm',
  },
  previous_claim_handling_follow_provider: {
    action: 'follow_provider',
    event_category: 'previous_claim_handling',
    event_label: 'Follow your provider',
  },
  previous_claim_handling_complete_request: {
    action: 'complete_request',
    event_category: 'previous_claim_handling',
    event_label: 'Complete my request',
  },
  previous_claim_handling_another_request: {
    action: 'another_request',
    event_category: 'previous_claim_handling',
    event_label: 'I have another request',
  },
  previous_claim_handling_need_help: {
    action: 'need_help',
    event_category: 'previous_claim_handling',
    event_label: 'I need help',
  },
  timeline_modify_car_destination_button: {
    action: 'modify_car_destination',
    event_category: 'previous_claim_handling',
    event_label: 'Edit',
  },
  timeline_cancel_car_destination_button: {
    action: 'cancel_car_destination',
    event_category: 'previous_claim_handling',
    event_label: 'Cancel',
  },
  timeline_modal_confirm_to_modify: {
    action: 'confirm_to_modify',
    event_category: 'timeline_modification_modal',
    event_label: 'Yes',
  },
  timeline_modal_refuse_to_modify: {
    action: 'refuse_to_modify',
    event_category: 'timeline_modification_modal',
    event_label: 'No',
  },
  timeline_confirm_cancelation_modal: {
    action: 'confirm_cancelation',
    event_category: 'timeline_cancelation_modal',
    event_label: 'Yes',
  },
  timeline_refuse_cancelation_modal: {
    action: 'refuse_cancelation',
    event_category: 'timeline_cancelation_modal',
    event_label: 'No',
  },
  fnol_accident_confirm: {
    action: 'confirm_fnol_accident',
    event_category: 'fnol_accident',
    event_label: 'Confirm',
  },
  fnol_accident_select_accident_report: {
    action: 'select_accident_report',
    event_category: 'fnol_accident',
  },
  fnol_accident_select_estimated_responsibility: {
    action: 'select_estimated_responsibility',
    event_category: 'fnol_accident',
  },
  fnol_appointment_confirm: {
    action: 'confirm_fnol_appointment',
    event_category: 'fnol_appointment',
    event_label: 'Confirm',
  },
  fnol_circumstances_confirm: {
    action: 'confirm_fnol_circumstances',
    event_category: 'fnol_circumstances',
    event_label: 'Confirm',
  },
  fnol_damages_confirm: {
    action: 'confirm_fnol_damages',
    event_category: 'fnol_damages',
    event_label: 'Confirm',
  },
  fnol_third_party_info_confirm: {
    action: 'confirm_fnol_third_party_info',
    event_category: 'fnol_third_party_info',
    event_label: 'Confirm',
  },
  fnol_situation_details_confirm: {
    action: 'confirm_situation_details',
    event_category: 'fnol_situation_details',
    event_label: 'Confirm',
  },
  fnol_situation_details_vehicle_damage: {
    action: 'select_vehicle_damage',
    event_category: 'fnol_situation_details',
  },
  fnol_situation_details_police_on_spot: {
    action: 'select_police_on_spot',
    event_category: 'fnol_situation_details',
  },
  fnol_situation_details_other_vehicle_involved: {
    action: 'select_other_vehicle_involved',
    event_category: 'fnol_situation_details',
  },
  // BenefitSelection
  benefit_selection_confirm: {
    action: 'benefit_selection_confirm',
    event_category: 'benefit_selection_confirmation',
  },
  benefit_selection: {
    action: 'benefit_select',
    event_category: 'benefit_selection',
  },
  // RentalCarWelcome:
  rental_car_welcome_check_conditions: {
    action: 'check_conditions',
    event_category: 'rental_car_welcome',
    event_label: 'I agreed and accepted conditions',
  },
  rental_car_welcome_accept_conditions: {
    action: 'accept_conditions',
    event_category: 'rental_car_welcome',
    event_label: 'Continue',
  },
  // RentalRegistration
  rental_registration_confirm: {
    action: 'confirm_registration',
    event_category: 'rental_registration_button',
    event_label: 'Confirm',
  },
  rental_registration_no_claim: {
    action: 'registration_no_claim_found',
    event_category: 'rental_registration_confirmation',
    event_label: 'No claim found at rental registration',
  },
  rental_registration_exceeded_seven_days: {
    action: 'registration_claim_exceeded_seven_days',
    event_category: 'rental_registration_confirmation',
    event_label: 'Found claim creation time exceeded seven days',
  },
  // RentalEligibility
  rental_eligibility_start_rental_booking: {
    action: 'start_rental_booking',
    event_category: 'rental_eligibility_button',
    event_label: 'START RENTAL BOOKING',
  },
  rental_eligibility_cancel_mission: {
    action: 'cancel_rental_mission',
    event_category: 'rental_eligibility_button',
    event_label: 'CANCEL MISSION',
  },
  // RentalCarDriverDetails:
  rental_car_driver_details_modal_confirm: {
    action: 'confirm_driver',
    event_category: 'rental_car_driver_modal',
    event_label: 'Yes',
  },
  rental_car_driver_details_modal_cancel: {
    action: 'cancel_driver',
    event_category: 'rental_car_driver_modal',
    event_label: 'No',
  },
  rental_car_driver_details_add_driver: {
    action: 'add_driver',
    event_category: 'rental_car_driver_details',
    event_label: 'Add driver',
  },
  rental_car_driver_details_remove_driver: {
    action: 'remove_driver',
    event_category: 'rental_car_driver_details',
    event_label: 'Remove driver',
  },
  rental_car_driver_details_confirm: {
    action: 'confirm_driver_details',
    event_category: 'rental_car_driver_details',
    event_label: 'Confirm',
  },
  // RentalInfoConfirm:
  rental_car_information_modify: {
    action: 'modify rental information',
    event_category: 'rental_car_info_confirm',
    event_label: 'modify',
  },
  rental_car_info_cancel_mission: {
    action: 'cancel mission',
    event_category: 'rental_car_info_confirm',
    event_label: 'Cancel mission',
  },
  rental_car_info_confirm_mission: {
    action: 'confirm mission',
    event_category: 'rental_car_info_confirm',
    event_label: 'Confirm',
  },
  rental_car_info_cancel_mission_modal_confirm: {
    action: 'cancel_mission_confirm',
    event_category: 'rental_car_info_cancel_modal',
    event_label: 'Yes',
  },
  rental_car_info_cancel_modal_abort: {
    action: 'cancel_mission_abort',
    event_category: 'rental_car_info_cancel_modal',
    event_label: 'Yes',
  },
  // RentalInformation:
  rental_information_select_pickup_current_location: {
    action: 'select_pickup_current_location',
    event_category: 'rental_information',
    event_label: 'Select current location',
  },
  rental_information_select_pickup_address_book: {
    action: 'select_pickup_from_address_book',
    event_category: 'rental_information',
    event_label: 'Select pick-up location from address book',
  },
  rental_information_different_dropoff_checkbox: {
    action: 'check_different_dropoff_area',
    event_category: 'rental_information',
    event_label: 'Different drop-off area',
  },
  rental_information_select_dropoff_address_book: {
    action: 'select_dropoff_from_address_book',
    event_category: 'rental_information',
    event_label: 'Select drop-off location from address book',
  },
  rental_information_address_description_tooltip: {
    action: 'address_description_tooltip_opened',
    event_category: 'rental_information',
    event_label: 'Address Description Tooltip',
  },
  rental_information_date_picker_description_tooltip: {
    action: 'date_picker_description_tooltip_opened',
    event_category: 'rental_information',
    event_label: 'Date Picker Description Tooltip',
  },
  rental_information_confirm_button: {
    action: 'confirm_rental_information',
    event_category: 'rental_information',
    event_label: 'Confirm',
  },
  // Rental Service:
  rental_service_date_picker_description_tooltip: {
    action: 'date_picker_description_tooltip_opened',
    event_category: 'rental_service',
    event_label: 'Date Picker Description Tooltip',
  },
  rental_service_mission_summary: {
    action: 'view_rental_summary',
    event_category: 'rental_service',
    event_label: 'Rental summary',
  },
  rental_service_extend_booking: {
    action: 'extend_booking',
    event_category: 'rental_service',
    event_label: 'Rental extend booking',
  },
  // Rental Summary:
  rental_car_summary_view_timeline: {
    action: 'view_timeline',
    event_category: 'rental_summary',
    event_label: 'View timeline',
  },
  rental_summary_extend_booking: {
    action: 'extend_booking',
    event_category: 'rental_summary',
    event_label: 'Rental extend booking',
  },
  // Rental Vehicle Location Confirm
  rental_vehicle_location_garage_confirm: {
    action: 'garage_confirm',
    event_category: 'rental_vehicle_garage_confirm',
    event_label: 'Yes',
  },
  rental_vehicle_location_garage_cancel: {
    action: 'cancel_rental_vehicle_location_garage',
    event_category: 'rental_vehicle_location_garage',
    event_label: 'No',
  },
  // Rental Vehicle Other Location
  rental_vehicle_other_location_confirm: {
    action: 'other_location_confirm',
    event_category: 'rental_vehicle_other_location',
    event_label: 'Confirm',
  },
  // Rental Vehicle Location Summary
  rental_vehicle_location_summary: {
    action: 'location_summary_confirm',
    event_category: 'rental_vehicle_location_summary',
    event_label: 'Confirm',
  },
  // Rental Extension Vehicle Location
  rental_extension_vehicle_location_yes: {
    action: 'confirm_rental_extension_vehicle_location',
    event_category: 'rental_extension_vehicle_location',
    event_label: 'Yes',
  },
  rental_extension_vehicle_location_no: {
    action: 'cancel_rental_extension_vehicle_location',
    event_category: 'rental_extension_vehicle_location',
    event_label: 'No',
  },
  rental_extension_not_eligible_return: {
    action: 'return_to_timeline',
    event_category: 'rental_extension_not_eligible',
    event_label: 'Return to timeline',
  },
  // Rental Extension Duration
  rental_extension_duration_confirm: {
    action: 'confirm_rental_extension_duration',
    event_category: 'rental_extension_duration_button',
    event_label: 'Confirm',
  },
  rental_extension_duration_cancel: {
    action: 'cancel_rental_extension_duration',
    event_category: 'rental_extension_duration_button',
    event_label: 'Cancel',
  },
  // Rental Extension Confirmation
  rental_extension_confirm: {
    action: 'rental_extension_confirm',
    event_category: 'rental_extension_confirmation',
    event_label: 'Confirm',
  },
  rental_extension_cancel: {
    action: 'rental_extension_cancel',
    event_category: 'rental_extension_confirmation',
    event_label: 'Cancel',
  },
  rental_extension_confirmation_cancel_modal_abort: {
    action: 'cancel_extension_abort',
    event_category: 'rental_extension_confirmation',
    event_label: 'Yes',
  },
  // Referential Highway Selection
  confirm_highway_selection: {
    action: 'confirm_highway_selection',
    event_category: 'referential_highway_selection',
    event_label: 'Confirm',
  },
  confirm_highway_not_known: {
    action: 'confirm_highway_not_known',
    event_category: 'referential_highway_selection',
    event_label: 'Not known',
  },
  // Referential Highway Direction
  referential_highway_direction_select: {
    action: 'referential_highway_direction_select',
    event_category: 'referential_highway_direction',
    event_label: 'Confirm',
  },
  // Referential POI Location
  poi_location_select: {
    action: 'select_poi_location',
    event_category: 'referential_poi_location',
    event_label: 'Confirm',
  },
  poi_location_not_listed: {
    action: 'poi_location_not_listed',
    event_category: 'referential_poi_location',
    event_label: 'Not listed',
  },
  poi_location_should_exit: {
    action: 'poi_location_should_exit',
    event_category: 'referential_poi_location',
    event_label: 'POI Should exit',
  },
  // Rental Extension Popup
  rental_extension_popup_yes: {
    action: 'rental_vehicle_already_returned',
    event_category: 'rental_extension_popup',
    event_label: 'Yes',
  },
  rental_extension_popup_no: {
    action: 'rental_vehicle_not_yet_returned',
    event_category: 'rental_extension_popup',
    event_label: 'No',
  },
  rental_extension_popup_close: {
    action: 'rental_extension_popup_closed',
    event_category: 'rental_extension_popup',
    event_label: 'Close',
  },
};
